import { render, staticRenderFns } from "./FaixaEtariaDataTable.vue?vue&type=template&id=8e482408"
import script from "./FaixaEtariaDataTable.vue?vue&type=script&lang=js"
export * from "./FaixaEtariaDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports